import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {CharacteristicTypeGroup} from '../../model/characteristic-type-group.model';
import {FieldValue} from '../../model/field-value.model';
import {FilterPanel} from '../../model/filter-panel.model';
import {FilterPanelHandler} from '../../model/filter-panel-handler.model';
import {HomeSearchFiltersAnalyticsHandler} from '../../home-search-filters-analytics-handler';
import { MultiSelectionOption, MultiSelectionOptions } from 'commons-lib';

@Component({
  selector: 'lps-characteristics-type-filter',
  templateUrl: './characteristics-type-filter.component.html',
  styleUrls: ['./characteristics-type-filter.component.scss']
})
export class CharacteristicsTypeFilterComponent implements OnInit, AfterViewInit {

  @ViewChild('clearTemplate') clearTemplate: TemplateRef<any>;

  @Input() panel: FilterPanel;
  @Input() value: FieldValue[] = [];
  @Output() valueChange: EventEmitter<FieldValue[]> = new EventEmitter<FieldValue[]>();
  @Output() cleanValue: EventEmitter<FieldValue[]> = new EventEmitter<FieldValue[]>();

  originalPanelName = '';
  panelHandler: FilterPanelHandler;
  filterGroup: CharacteristicTypeGroup[] = [
    {
      field: 'rooms',
      groupName: 'Dormitórios',
      options: this.buildFilter()
    },
    {
      field: 'parkingLots',
      groupName: 'Vagas',
      options: this.buildFilter()
    },
    {
      field: 'suites',
      groupName: 'Suítes',
      options: this.buildFilter(),
    },
    {
      field: 'bathrooms',
      groupName: 'Banheiros',
      options: this.buildFilter(),
    }
  ];

  constructor(
    private googleAnalyticsEventManger: HomeSearchFiltersAnalyticsHandler
  ) {}

  ngOnInit() {
    this.panelHandler = new FilterPanelHandler(this.panel);
    this.originalPanelName = this.panel.name;
    this.value = this.value.filter(v => Array.isArray(v.value) ? v.value.length : v.value);
    if (this.value && this.value.length) {
      this.initValues();
    }
  }

  ngAfterViewInit() {
    // ChangeDetectorRef não funciona mais? por isso tem 35% de rejeição na comunidade de devs
    setTimeout(() => {
      this.panelHandler.setPanelExtraTemplate(this.clearTemplate);
      this.setPanelHeader();
    }, 0);
  }

  initValues() {
    this.value
      .forEach((fieldValue: FieldValue) => {
        const f = this.filterGroup.find(fg => fg.field === fieldValue.field);

        if (f) {
          const multiSelectionOptions = f.options;
          multiSelectionOptions.items.forEach((m) => {
            if (fieldValue.value) {
              const value = Array.isArray(fieldValue.value) ? fieldValue.value : [fieldValue.value];
              const isSelected = value.some(fv => m.getValue() === fv);
              if (isSelected && !m.isToggled()) {
                m.toggle();
              }
            }
          });
        }
      });
  }

  buildFilter() {
    return new MultiSelectionOptions([
      new MultiSelectionOption('1', '1'),
      new MultiSelectionOption('2', '2'),
      new MultiSelectionOption('3', '3'),
      new MultiSelectionOption('4+', '4')
    ]);
  }

  cleanFilter(evt: MouseEvent) {
    evt.stopPropagation();
    this.filterGroup.forEach((group) => {
      group.options.unselectAllOptions();
    });
    this.value = [];
    this.emit();
    this.cleanValue.emit(this.value);
  }

  sendEventForSelectedOptions(label: string, options: MultiSelectionOptions): void {
    const amountSelected = options.getSelectedOptions()
      .map(selectedOption => selectedOption.getValue())
      .join('/');
    const eventLabel = `características-do-imóvel:${label.toLowerCase()}:${amountSelected}`;
    this.googleAnalyticsEventManger.sendEvent(eventLabel);
  }

  emit() {
    const groupValues: FieldValue[] = this.filterGroup
      .reduce((group: any[], item) => {
        const {field, options} = item;
        const value = options.getSelectedOptions().map(o => o.getValue());
        return [...group, {field, value}];
      }, []);

    this.value = groupValues.filter(g => g.value.length);
    this.valueChange.emit(this.value);
    this.setPanelHeader();
  }

  setPanelHeader() {
    this.panelHandler.setPanelHeader(
      this.value.length
        ? `${this.originalPanelName} (${this.value.length})`
        : this.originalPanelName
    );
  }
}
